import React from "react";
import { components, MenuProps } from "react-select";

import { slideInFromBottom } from "shared/styles/constants";
import { StyledMenu } from "../styles";

export const Menu: React.FC<MenuProps<any, false>> = (props) => (
  <StyledMenu {...slideInFromBottom}>
    <components.Menu {...props} />
  </StyledMenu>
);
